'use client';

import { usePathname } from 'next/navigation';
import { Header, Footer } from '@/components/common';
import ReduxProvider from '@/redux/provider';
import { AnalyticsProvider } from '@/providers';
import ScrollRestoration from '../../scrollRestoration/scrollRestoration.component';
import type { RootState } from '@/redux/store';

interface TProps {
  font: any;
  children: React.ReactNode;
  /** Read from the request cookie by the server layout - see ReduxProvider. */
  initialLocation?: RootState['location'] | null;
}

export default function PageWrapper({ children, initialLocation }: TProps) {
  const pathname = usePathname();
  const showHeaderFooter = !pathname.startsWith('/curiobit');

  return (
    <ReduxProvider initialLocation={initialLocation}>
      <AnalyticsProvider>
        <ScrollRestoration />
        {showHeaderFooter && <Header />}
        <main className='bg-white'>{children}</main>
        {showHeaderFooter && <Footer />}
      </AnalyticsProvider>
    </ReduxProvider>
  );
}
